import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as yup from 'yup';
import {useApiService} from "../context/ApiServiceContext";
import linkngoMain from "../assets/images/linkngo-main.png";
import byRego from "../assets/images/rego-logo.png";
import {makeStyles, Theme, Typography} from "@mui/material";

const ResetPassword: React.FC = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const navigate = useNavigate();

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const hash = searchParams.get('hash');
    const apiService = useApiService();

    useEffect(() => {
        if (hash === undefined) {
            navigate("/")
        }
    }, [hash])

    const passwordSchema = yup.object().shape({
        password: yup.string()
            .required('שדה חובה')
            .min(6, 'הסיסמא צריכה להכיל לפחות 6 תווים')
            .matches(/[a-z]/, 'הסיסמא צריכה להכיל לפחות אות קטנה אחת')
            .matches(/[A-Z]/, 'הסיסמא צריכה להכיל לפחות אות גדולה אחת')
            .matches(/[!@#$%^&*(),.?":{}|<>]/, 'הסיסמא צריכה להכיל לפחות תו מיוחד אחד'),
        confirmPassword: yup.string()
            .oneOf([yup.ref('password'), ''], 'הסיסמאות חייבות להיות תואמות')
    });

    const validatePasswords = async () => {
        try {
            await passwordSchema.validate({password, confirmPassword});
            return true;
        } catch (error: any) {
            toast.error(error.message);
            return false;
        }
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!(await validatePasswords())) {
            return;
        }

        try {
            // Replace with your API endpoint
            await apiService.api.post('/oauth/reset-password', {token: hash, newPassword: password});
            toast.success('הסיסמא אופסה בהצלחה');
            navigate('/'); // Redirect to login page or dashboard
        } catch (error) {
            toast.error('בעיה באיפוס הסיסמא, נסה שוב מאוחר יותר');
        }
    };

    return (
        <></>
    );
};

export default ResetPassword;
